import { useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { driverModel } from '~/entities/common/Driver'
import { BreadcrumbsList } from '~/shared/ui/Breadcrumbs'

export const useBreadcrumbs = (driverId: string) => {
  const fullName = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getFullName(),
  )

  const generalBalanceBreadcrumbs = useMemo(
    (): BreadcrumbsList => [
      {
        titleI18n: 'drivers',
        link: '/drivers',
      },
      {
        title: fullName || '...',
        link: `/drivers/${driverId}/details`,
      },
      {
        titleI18n: 'balances',
        link: `/drivers/${driverId}/balance/current`,
      },
    ],
    [driverId, fullName],
  )

  const currentViewTransactionBreadcrumbs = useMemo(
    (): BreadcrumbsList => [
      ...generalBalanceBreadcrumbs,
      {
        titleI18n: 'current balance',
        link: `/drivers/${driverId}/balance/current`,
      },
    ],
    [driverId, generalBalanceBreadcrumbs],
  )

  const byDeptViewTransactionBreadcrumbs = useMemo(
    (): BreadcrumbsList => [
      ...generalBalanceBreadcrumbs,
      {
        titleI18n: 'credit balance',
        link: `/drivers/${driverId}/balance/by-dept`,
      },
    ],
    [driverId, generalBalanceBreadcrumbs],
  )

  const byBonusViewTransactionBreadcrumbs = useMemo(
    (): BreadcrumbsList => [
      ...generalBalanceBreadcrumbs,
      {
        titleI18n: 'bonus balance',
        link: `/drivers/${driverId}/balance/by-bonus`,
      },
    ],
    [driverId, generalBalanceBreadcrumbs],
  )

  const byDepositViewTransactionBreadcrumbs = useMemo(
    (): BreadcrumbsList => [
      ...generalBalanceBreadcrumbs,
      {
        titleI18n: 'deposit balance',
        link: `/drivers/${driverId}/balance/by-deposit`,
      },
    ],
    [driverId, generalBalanceBreadcrumbs],
  )

  return {
    currentViewTransactionBreadcrumbs,
    byDeptViewTransactionBreadcrumbs,
    byBonusViewTransactionBreadcrumbs,
    byDepositViewTransactionBreadcrumbs,
  }
}
